import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

/**
 * Define o tema (dark/light) na aplicação, considerando
 * o modo do sistema operacional ou a escolha do usuário.
 */
export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    document.body.classList.add('dark');
    document.documentElement.setAttribute('style', 'color-scheme: dark;');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.setAttribute('style', 'color-scheme: light;');
  }
};

/**
 * Observa mudanças no tema (dark/light) da aplicação.
 * 🔸 Compatível com Vue 2 (Options API) e Vue 3 (Options API).
 *
 * Para usar no componente:
 * - mounted() {
 *     getChangesOnTheme(this.currentDisplayTheme, this);
 *   }
 * - Adicione em methods:
 *   handleThemeChange(newTheme) {
 *     this.currentDisplayTheme = newTheme;
 *   }
 */
export const getChangesOnTheme = (observedColorScheme, vueInstance) => {
  const htmlElement = document.querySelector('html');

  const checkColorScheme = () => {
    const styles = window.getComputedStyle(htmlElement);
    const colorScheme = styles.getPropertyValue('color-scheme').trim();

    if (colorScheme !== observedColorScheme) {
      observedColorScheme = colorScheme;
      vueInstance.handleThemeChange(colorScheme);
    }
  };

  checkColorScheme();

  const observer = new MutationObserver(checkColorScheme);
  observer.observe(htmlElement, { attributes: true });

  // 🔥 Compatível com Vue 2 e Vue 3 (Options API)
  if (typeof vueInstance.$once === 'function') {
    // Vue 2
    vueInstance.$once('hook:beforeDestroy', () => {
      observer.disconnect();
    });
  } else if (vueInstance.$ && typeof vueInstance.$.um === 'object') {
    // Vue 3 Options API (internamente Vue 3 guarda os unmounted hooks em `um`)
    const unmountedHooks = vueInstance.$.um;
    if (Array.isArray(unmountedHooks)) {
      unmountedHooks.push(() => {
        observer.disconnect();
      });
    }
  } else {
    // eslint-disable-next-line no-console
    console.warn(
      '[getChangesOnTheme] Não foi possível registrar observer. Verifique se está usando Composition API ou alguma abordagem não suportada por este helper.'
    );
  }
};
